import {
  Box,
  TextField,
  Typography,
  Grid,
  Alert,
  AlertTitle,
} from "@mui/material";
import React, { ChangeEvent, useState, useEffect } from "react";
import InputMask from "react-input-mask";
import { FormData } from "..";

interface Props {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  formValid: boolean;
  setFormValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Comunicacao = ({
  formData,
  setFormData,
  formValid,
  setFormValid,
}: Props) => {
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedData = { ...prev, [name]: value };

      if (name === "telefone") {
        updatedData.telefone = value.replace(/\D/g, "").slice(0, 13); // Remove caracteres não numéricos e permite 13 dígitos
      }
      if (name === "email") {
        updatedData.email = value.trim(); // Remove espaços extras
      }

      return updatedData;
    });
  };

  useEffect(() => {
    const errors: { [key: string]: string } = {};

   // Validação do telefone (opcional, mas se preenchido, deve ser válido)
if (formData.telefone && !/^\d{13}$/.test(formData.telefone)) {
  errors.telefone =
    "Telefone inválido. Use um número válido com código do país, DDD e o nono dígito.";
}

// Validação do e-mail (opcional, mas se preenchido, deve ser válido)
if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
  errors.email = "E-mail inválido.";
}


    setFormErrors(errors);
    setFormValid(Object.keys(errors).length === 0);
  }, [formData, setFormValid]);

  return (
    <Box>
      <Alert severity="warning" sx={{ mb: 1, mt: 1 }}>
        <AlertTitle>
          <Typography variant="h6" fontWeight="bold">
            Atenção!
          </Typography>
        </AlertTitle>
        <Typography variant="body1" fontSize={14}>
          O <strong>telefone</strong>
          {formData.telefone && `(${formData.telefone})`} e o{" "}
          <strong>e-mail</strong>
          {formData.email && `(${formData.email})`} cadastrados serão utilizados
          como canais de comunicação e também poderão ser usados para
          recuperação de senha caso necessário.
        </Typography>
      </Alert>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputMask
            mask="(99) 99 99999-9999"
            value={formData.telefone || "55 54 9"} // Define 55 54 9 como default se estiver vazio
            onChange={handleChange}
          >
            {() => (
              <TextField
                fullWidth
                label="Telefone"
                name="telefone"
                margin="normal"
                error={!!formErrors.telefone}
                helperText={
                  formErrors.telefone ||
                  "Ao cadastrar o telefone, você aceita receber notificações via WhatsApp."
                }
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="E-mail"
            name="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            error={!!formErrors.email}
            helperText={
              formErrors.email ||
              "Ao cadastrar o e-mail, você aceita receber notificações do sistema."
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};
